import { Badge } from "@chakra-ui/react";

interface StageBadgeProps {
  stageId: string;
}

const stageConfig: Record<string, { label: string; bg: string; color: string }> = {
  immediate: { label: "Immediate", bg: "teal.100", color: "teal.800" },
  preboarding: { label: "Preboarding", bg: "purple.100", color: "purple.800" },
  // day1 folds into the Week 1 display group
  day1: { label: "Week 1", bg: "blue.100", color: "blue.800" },
  week1: { label: "Week 1", bg: "blue.100", color: "blue.800" },
  week2: { label: "Week 2", bg: "cyan.100", color: "cyan.800" },
  month1: { label: "Month 1", bg: "cyan.100", color: "cyan.800" },
  month2: { label: "Month 2", bg: "green.100", color: "green.800" },
  month3: { label: "Month 3", bg: "green.100", color: "green.800" },
  afterMonth3: { label: "3+ Months", bg: "orange.100", color: "orange.800" },
  afterMonth6: { label: "6+ Months", bg: "red.100", color: "red.800" },
  afterMonth12: { label: "Past 1 Year", bg: "pink.100", color: "pink.800" },
  dependency: { label: "Dependency", bg: "gray.100", color: "gray.800" },
};

const newHireStageConfig: Record<string, { label: string; bg: string; color: string }> = {
  // New-hire view flattens every stage to purple; only labels vary.
  immediate: { label: "Preboarding", bg: "purple.100", color: "purple.800" },
  preboarding: { label: "Preboarding", bg: "purple.100", color: "purple.800" },
  day1: { label: "Week 1", bg: "purple.100", color: "purple.800" },
  week1: { label: "Week 1", bg: "purple.100", color: "purple.800" },
  week2: { label: "Week 2", bg: "purple.100", color: "purple.800" },
  month1: { label: "Month 1", bg: "purple.100", color: "purple.800" },
  month2: { label: "Month 2", bg: "purple.100", color: "purple.800" },
  month3: { label: "Month 3", bg: "purple.100", color: "purple.800" },
  afterMonth3: { label: "3+ Months", bg: "purple.100", color: "purple.800" },
  afterMonth6: { label: "6+ Months", bg: "purple.100", color: "purple.800" },
  afterMonth12: { label: "Past 1 Year", bg: "purple.100", color: "purple.800" },
  dependency: { label: "TBD", bg: "purple.100", color: "purple.800" },
};

export default function StageBadge({ stageId }: StageBadgeProps) {
  const config = stageConfig[stageId] || { label: stageId, bg: "gray.50", color: "gray.700" };

  return (
    <Badge
      bg={config.bg}
      color={config.color}
      fontSize="10px"
      fontWeight="semibold"
      px={2}
      py={0.5}
      borderRadius="md"
      textTransform="none"
    >
      {config.label}
    </Badge>
  );
}

export function NewHireStageBadge({ stageId }: StageBadgeProps) {
  const config = newHireStageConfig[stageId] || { label: "TBD", bg: "purple.100", color: "purple.800" };

  return (
    <Badge
      bg={config.bg}
      color={config.color}
      fontSize="10px"
      fontWeight="semibold"
      px={2}
      py={0.5}
      borderRadius="md"
      textTransform="none"
    >
      {config.label}
    </Badge>
  );
}
